<div class="toolbar" *ngIf="showShare">
  <button type="button"
          class="btn-value-components primary t-bottom t-no-arrow"
          [attr.aria-label]="'SHARE_CONVERSATION_BUTTON_TOOLTIP' | translate"
          [disabled]="disabled"
          (click)="onShareClick()">
    <img src="assets/icons/icon-share-icon-1.svg" alt="Share" class="share-icon share-icon-default">
  </button>
</div>
